var module;
// LICENSE_CODE ZON ISC
'use strict'; /*zlint node, br*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  if (!is_node) ;else ;
  define(['jquery', '/util/etask.js', '/util/date.js', '/util/escape.js', '/util/zerr.js', 'events'], function ($, etask, date, zescape, zerr, events) {
    var E = ajax;
    var assign = Object.assign;
    E.events = new events.EventEmitter();
    E.json = function (opt) {
      return ajax(assign({}, opt, {
        json: 1
      }));
    };
    E.abort = function (aj) {
      aj.goto('abort');
    };
    // XXX arik: need test
    function ajax(opt) {
      var timeout = opt.timeout || 20 * date.ms.SEC,
        slow = opt.slow || 2 * date.ms.SEC;
      var retry = opt.retry,
        data = opt.data,
        qs = zescape.qs(opt.qs);
      var url = zescape.uri(opt.url, qs),
        perr = opt.perr;
      var response_etag, response_status;
      // opt.type is deprecated
      var method = opt.method || opt.type || 'GET';
      var data_type = opt.json ? 'json' : 'text';
      var t0 = Date.now();
      var xhr;
      zerr.debug('ajax(' + data_type + ') url ' + url + ' retry ' + retry);
      return etask([function () {
        var ajopt = {
          dataType: data_type,
          type: method,
          url: url,
          data: data,
          timeout: timeout,
          xhrFields: {},
          no_throw: opt.no_throw
        };
        if (opt.headers) ajopt.headers = opt.headers;
        if (opt.content_type) ajopt.contentType = opt.content_type;
        if (opt.with_credentials) ajopt.xhrFields.withCredentials = true;
        if (opt.onprogress) ajopt.xhrFields.onprogress = opt.onprogress;
        if (opt.onuploadprogress) {
          ajopt.xhr = function () {
            var _xhr = $.ajaxSettings.xhr();
            _xhr.upload.onprogress = opt.onuploadprogress;
            return _xhr;
          };
        }
        if (opt.multipart) {
          ajopt.contentType = false;
          ajopt.processData = false;
          delete ajopt.dataType;
        }
        if (opt.async !== undefined) ajopt.async = opt.async;
        xhr = $.ajax(ajopt);
        var _this = this;
        if (xhr instanceof etask) return xhr;
        xhr.done(function (v, status_text, _xhr) {
          response_etag = _xhr.getResponseHeader('etag');
          response_status = _xhr.status;
          var server_ts = +_xhr.getResponseHeader('x-hola-ts');
          if (server_ts) E.events.emit('server_ts', server_ts);
          var conf_ver = +_xhr.getResponseHeader('x-hola-conf-ver');
          if (conf_ver) E.events.emit('conf_ver', conf_ver);
          _this.continue(v);
        });
        xhr.fail(function (_xhr, status_text, err) {
          if (data_type == 'json' && _xhr && _xhr.status == 200 && ['', 'ok', 'OK'].includes(_xhr.responseText)) {
            _this.continue(null);
            return;
          }
          if (!err && data_type == 'text' && _xhr && _xhr.responseText) err = _xhr.responseText;
          _this.throw(err instanceof Error ? err : new Error('' + err));
        });
        return this.wait();
      }, function catch$(err) {
        xhr = xhr || {};
        var status = xhr.status;
        var status_text = xhr.statusText;
        var response_text = xhr.responseText;
        if (xhr instanceof etask) {
          var hola_info = err.hola_info || {};
          status = hola_info.status;
          status_text = hola_info.status_text;
          response_text = hola_info.response_text;
        }
        zerr('ajax(' + data_type + ') failed url ' + url + ' data ' + zerr.json(data).substr(0, 200) + ' status: ' + status + ' ' + status_text + '\nresponseText: ' + (response_text || '').substr(0, 200));
        if (retry && (!opt.should_retry || opt.should_retry(err, {
          status: status
        }))) {
          return this.return(ajax(assign({}, opt, {
            retry: retry - 1
          })));
        }
        if (err instanceof Error && err.hola_info) throw err;
        if (status_text == 'timeout') E.events.emit('timeout', this);
        if (xhr instanceof etask) {
          if (xhr.headers && xhr.headers.get('x-hola-ts')) E.events.emit('server_ts', +xhr.headers.get('x-hola-ts'));
        } else if (xhr.getResponseHeader('x-hola-ts')) E.events.emit('server_ts', +xhr.getResponseHeader('x-hola-ts'));
        if (opt.no_throw) {
          return {
            err: err,
            url: url,
            method: method,
            status: +status || 0,
            data: get_res_data(xhr),
            xhr: xhr,
            // legacy
            error: status_text || 'no_status',
            message: response_text
          };
        }
        err.hola_info = {
          url: url,
          method: method,
          status: status,
          data: get_res_data(xhr),
          response_text: response_text
        };
        if (xhr instanceof etask && xhr.headers) err.x_error = xhr.headers.get('X-Hola-Error');else err.x_error = xhr.getResponseHeader('X-Hola-Error');
        throw err;
      }, function (data) {
        if (xhr instanceof etask && xhr.headers) {
          var server_ts = +xhr.headers.get('x-hola-ts');
          if (server_ts) E.events.emit('server_ts', server_ts);
          var conf_ver = +xhr.headers.get('x-hola-conf-ver');
          if (conf_ver) E.events.emit('conf_ver', conf_ver);
        }
        var t = Date.now() - t0;
        zerr[t > slow ? 'err' : 'debug']('ajax(' + data_type + ') ' + (t > slow ? 'SLOW ' : 'ok ') + t + 'ms url ' + url);
        if (t > slow && perr && !url.includes('client_cgi/perr')) {
          perr({
            id: 'be_ajax_slow',
            info: t + 'ms ' + url,
            rate_limit: {
              count: 1
            }
          });
        }
        if (E.do_op) E.do_op(data && data.do_op);
        if (opt.full_response) {
          return this.return({
            data: data,
            etag: response_etag,
            status: response_status
          });
        }
        return this.return(data);
      }, function abort() {
        // reachable only via E.abort
        xhr.abort();
      }]);
    }
    ['GET', 'POST', 'PUT', 'DELETE'].forEach(function (m) {
      E[m.toLowerCase()] = function (url, opt) {
        url = typeof url == 'string' ? {
          url: url
        } : url;
        opt = assign({
          method: m,
          json: 1
        }, url, opt);
        if (!{
          get: 1,
          delete: 1
        }[opt.method.toLowerCase()] && opt.data != null && typeof opt.data != 'string') {
          opt.content_type = opt.content_type || 'application/json';
          if (opt.content_type.startsWith('application/json')) opt.data = JSON.stringify(opt.data);
        }
        return ajax(opt);
      };
    });
    function get_res_data(xhr) {
      if (xhr.responseJSON != null && xhr.responseJSON !== '') return xhr.responseJSON;
      var content_type = xhr.getResponseHeader('content-type') || '';
      if (xhr.responseText && content_type.includes('application/json')) {
        try {
          return JSON.parse(xhr.responseText);
        } catch (e) {}
      }
      return xhr.responseText || '';
    }
    return E;
  });
})();